<div class="input-wrapper mb-3" [ngClass]="customClass">
  <label class="header form-label" *ngIf="header">
    {{ header }} <span *ngIf="keyRequired" class="text-danger">*</span>
  </label>

  <div [ngClass]="hasIcon ? 'input-group' : ''">
    <span class="input-group-text" *ngIf="hasIcon">
      <i *ngIf="isFaIcon" [ngClass]="resolvedIconClass"></i>
      <span *ngIf="!isFaIcon" class="icon-text">{{ iconText }}</span>
    </span>

    <input
      [readOnly]="readonly"
      [disabled]="disabled"
      [type]="type || 'text'"
      class="form-control forminput"
      [placeholder]="placeholder"
      [ngClass]="{
        'error-border': showRequiredError || showPatternError,
        'has-icon-input': hasIcon
      }"
      [(ngModel)]="value"
      (input)="onInputChange($event)"
      (blur)="onSubmitValue($event); onInputChange($event)"
    />
  </div>

  <!-- Help text / Subtitle -->
  <div *ngIf="helpText" class="form-text text-muted">
    {{ helpText }}
  </div>

  <!-- Required error -->
  <div *ngIf="showRequiredError" class="text-danger small mt-1">
    This field is required.
  </div>

  <!-- Pattern error -->
  <div *ngIf="showPatternError" class="text-danger small mt-1">
    {{ patternMessage || 'Value does not match the required format.' }}
  </div>
</div>

